import React from 'react';
import { Spin } from 'antd';

function LoadingOverlay(): React.ReactElement {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 300,
      }}
    >
      <Spin size="large" />
    </div>
  );
}

export default LoadingOverlay;
